import { Dict } from 'types/generics'

export const createDictFromArrayHandler =
  <ItemType extends Object>(itemKey: keyof ItemType) =>
  (array: ItemType[]) => {
    const dict: Dict<ItemType> = {}
    array.forEach((item) => (dict[item[itemKey as string]] = item))
    return dict
  }
